import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'fury-uploade-service-agreement',
  templateUrl: './uploade-service-agreement.component.html',
  styleUrls: ['./uploade-service-agreement.component.scss']
})
export class UploadeServiceAgreementComponent implements OnInit {
  selectedFileName!: string;
  serviceAgreementForm : FormGroup = new FormGroup({
    agreementFile: new FormControl('', [Validators.required])
  });

  constructor(
    public dialogRef: MatDialogRef<UploadeServiceAgreementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
  }
  uploadDocumentInit(e: any, uploadedFile: any) {
    for (let i = 0; i < uploadedFile.files.length; i++) {
      if(e.target.files[i].size < 8388608){
        if (e.target.files[i].type === 'application/pdf') {
          const file = uploadedFile.files[i];
          this.selectedFileName = e.target.files[i].name;
          this.serviceAgreementForm.patchValue({ agreementFile: file });
          } else {
          this.apiService.alert('Only .PDF are supported.', 'error');
          }
      }  else {
         this.apiService.alert('PDF size must be less then 8 MB.', 'error');
      }
    }
  }
  uploadeServiceAgreement(){
    if(this.serviceAgreementForm.valid){
      const postData = new FormData();
      postData.append('agreementFile', this.serviceAgreementForm.value.agreementFile);
      this.apiService.postMultiData(`admin/service-agreement/upload-agreement-file/${this.data}`, postData).subscribe((res: HttpResponse<any>)=>{
        if(res.body){
          this.apiService.alert(res.body.message, ErrorType.Success);
          this.dialogRef.close(true);
        }
      }, (err: HttpErrorResponse)=>{
        this.apiService.alert(err.message, ErrorType.Error);
      })
    } else {
      this.serviceAgreementForm.markAllAsTouched();
    }
  }
}
